webpackJsonp([47],{

/***/ "GnEM":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "html/title-block_a8ee90e0fb7f23d269bf6c5c910e4b46.html";

/***/ }),

/***/ "dhyF":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var TitleBlock = (function () {
    TitleBlock.$inject = ["$sce", "TranslateSvc"];
    function TitleBlock($sce, TranslateSvc) {
        var _this = this;
        this.$sce = $sce;
        this.TranslateSvc = TranslateSvc;
        this.getHtml = function (html) {
            return _this.$sce.trustAsHtml(html);
        };
        this.translate = function (str) {
            return _this.TranslateSvc.has(str) ? _this.TranslateSvc.get(str) : str;
        };
        var mapText = _.compose(this.getHtml, this.translate);
        this.tbTitle = mapText(this.tbTitle);
        this.description = mapText(this.description);
    }
    return TitleBlock;
}());
angular.module('animatronApp.titleBlock', []).component('titleBlock', {
    bindings: {
        tbTitle: '<',
        description: '<',
        color: '@',
        size: '@'
    },
    controller: TitleBlock,
    templateUrl: __webpack_require__("GnEM")
});


/***/ })

});


// WEBPACK FOOTER //
// javascripts/47-28dc41a6a889e793a2e2.min.js